<p-dialog
  styleClass="notes-overlay"
  [(visible)]="isVisible"
  modal="true"
  [baseZIndex]="10000"
  [dismissableMask]="true"
  [style]="{ 
    width: '488px',  
    height:'340px',
    borderRadius: '25px' 
}"
 [appendTo]="'body'"

>
  <div class="notes-modal-content">
    <div class="header">
      <span>Notes</span>
      <button (click)="closeModal()">
        <img src="assets/Inbox/close_icon_white.svg" alt="close" />
      </button>
    </div>
    <div class="content">
      <label for="notes">Note:</label>
      <div class="textarea-wrapper">
        <textarea
          id="notes"
          rows="5"
          [(ngModel)]="noteText"
          maxlength="250"
          placeholder="Type here"
          autofocus
        ></textarea>
        <span id="word-count">{{ noteText.length }}/250</span>
      </div>
    </div>
    <div class="footer">
      <button
        pButton
        label="Cancel"
        class="cancel-button"
        (click)="closeModal()"
      ></button>
      <button
        pButton
        label="Submit"
        class="submit-button"
        (click)="submitNotes()"
      ></button>
    </div>
  </div>
</p-dialog>
